import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import { useVelocidadeConsumoSection } from "./use-velocidade-consumo-section";
import { VelocidadeConsumoSectionView } from "./view-velocidade-consumo-section";

export function VelocidadeConsumoSection(props: EmbarcacaoDetailSectionProps) {
  const vm = useVelocidadeConsumoSection(props);

  return <VelocidadeConsumoSectionView {...vm} />;
}

export type * from "./types-velocidade-consumo-section";
